<div class="login-page">
    <app-loading [isLoading]="true" />
</div>
